import { ReactElement, useCallback } from 'react';
import { Stack, Tooltip } from '@mui/material';
import {
  faMagnifyingGlass as SearchIcon,
  faFilter as FilterIcon,
  faArrowsRotate as RefreshIcon,
} from '@fortawesome/free-solid-svg-icons';

import { useToggleMenu } from '~hooks/useToggleMenu';
import OrdersFilterMenuGiver from '~components/OrdersFilterMenuGiver';

import { useDashboardVariantV2GiverContext } from '../../../../../../Context';
// eslint-disable-next-line max-len
import { useDashboardVariantV2GiverInPreparationFiltersContext } from '../../../../../../InPreparationFiltersContext';
import { useDashboardVariantV2GiverContentInPreparationTabContext } from '../../../Context';

import {
  DashboardVariantV2GiverContentActionsFieldWithButtonGroup,
  DashboardVariantV2GiverContentActionsTextField,
  DashboardVariantV2GiverContentActionsIconButton,
  DashboardVariantV2GiverContentActionsIconButtonIcon,
} from '../../../../../styles';

const DashboardVariantV2GiverContentInPreparationTabActionsFilters =
  (): ReactElement => {
    const {
      actions: {
        ignoreRefreshBySocket: { toggleValue: toggleIgnoreRefreshBySocket },
        expandedHasChangeOrdersAlert: {
          toggleValue: toggleExpandedHasChangeOrdersAlert,
        },
        modifiedItemsIdBySocket: { setValue: setModifiedItemsIdBySocket },
      },
    } = useDashboardVariantV2GiverContext();

    const {
      autocompletesRefs,
      filters: {
        filters,
        filtersActives,
        setFilterByKey,
        handleChangeInputFilter,
        handleApplyFilter,
        handleResetFilters,
        handleClearFilters,
      },
    } = useDashboardVariantV2GiverInPreparationFiltersContext();

    const {
      actions: { reloadDataAndResetSelectedRows },
    } = useDashboardVariantV2GiverContentInPreparationTabContext();

    const [
      anchorElOrdersFiltersMenu,
      openOrdersFiltersMenu,
      ,
      handleToggleWithValue,
    ] = useToggleMenu();

    const handleRefreshData = useCallback(() => {
      reloadDataAndResetSelectedRows();

      toggleExpandedHasChangeOrdersAlert(false);
      toggleIgnoreRefreshBySocket(false);
      setModifiedItemsIdBySocket([]);
    }, [
      reloadDataAndResetSelectedRows,
      toggleExpandedHasChangeOrdersAlert,
      toggleIgnoreRefreshBySocket,
      setModifiedItemsIdBySocket,
    ]);

    return (
      <Stack direction="row" spacing={2}>
        <Stack direction="row" spacing={1}>
          <DashboardVariantV2GiverContentActionsFieldWithButtonGroup>
            <DashboardVariantV2GiverContentActionsTextField
              label="Nro. Orden / Nro. Tracking / Grupo"
              name="search"
              fullWidth
              value={filters.search ?? ''}
              onChange={handleChangeInputFilter}
            />

            <Tooltip title="Buscar..." arrow>
              <span style={{ display: 'flex' }}>
                <DashboardVariantV2GiverContentActionsIconButton
                  color="secondary"
                  variant="contained"
                  onClick={handleApplyFilter}
                  disabled={!filters.search}
                >
                  <DashboardVariantV2GiverContentActionsIconButtonIcon
                    icon={SearchIcon}
                  />
                </DashboardVariantV2GiverContentActionsIconButton>
              </span>
            </Tooltip>
          </DashboardVariantV2GiverContentActionsFieldWithButtonGroup>

          <Tooltip title="Mas filtros" arrow>
            <DashboardVariantV2GiverContentActionsIconButton
              color="primary"
              variant="contained"
              ref={anchorElOrdersFiltersMenu}
              onClick={() => handleToggleWithValue(true)}
            >
              <DashboardVariantV2GiverContentActionsIconButtonIcon
                icon={FilterIcon}
              />
            </DashboardVariantV2GiverContentActionsIconButton>
          </Tooltip>

          <Tooltip title="Refrescar listado" arrow>
            <DashboardVariantV2GiverContentActionsIconButton
              color="secondary"
              variant="outlined"
              onClick={handleRefreshData}
            >
              <DashboardVariantV2GiverContentActionsIconButtonIcon
                icon={RefreshIcon}
              />
            </DashboardVariantV2GiverContentActionsIconButton>
          </Tooltip>

          <OrdersFilterMenuGiver
            anchorEl={anchorElOrdersFiltersMenu.current}
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            transformOrigin={{ horizontal: 'center', vertical: 'top' }}
            open={openOrdersFiltersMenu}
            onClose={() => handleToggleWithValue(false)}
            type="inPreparation"
            currentFilters={{
              autocompletesRefs,
              filters,
              activeFilters: filtersActives,
              onChangeFilterInput: setFilterByKey,
              onResetFilters: handleResetFilters,
              onApplyFilters: handleApplyFilter,
              onClearFilters: () => handleClearFilters(true),
            }}
          />
        </Stack>
      </Stack>
    );
  };

export default DashboardVariantV2GiverContentInPreparationTabActionsFilters;
